import React, { forwardRef } from "react"

import { css, logTool } from "@jsUtils"
import Styles from "./pagecircles.module.scss"

const log = logTool(false)

/**
 * @param {object} props - react props
 * @param {string} props.alignment - style string name
 * @param {string} props.color - style color name
 * @param {string} props.fromTop - style offset value
 * @param {boolean} props.orbit - do we have an orbiter?
 * @param {string} props.size - style size name
 * @param {boolean} props.ready - are we ready?
 * @param {object} props.extraClasses - extra classNamees for each level
 * @param {string} props.extraClasses.wrapper
 * @param {string} props.extraClasses.circle
 * @param {string} props.extraClasses.ring
 * @param {string} props.extraClasses.dot
 * @param {object} ref - react ref
 * @returns {nodes} react nodes in a forwardRef wrapper
 *
 * Use ExtraClasses like so:
 *    <PageCircles
 *      settings={...
 *      extraClasses: {
 *        wrapper: Styles.wrap,
 *        circle: Styles.circle,
 *        ring: Styles.ring,
 *        dot: Styles.dot
 *      }
 *      ...}
 */
const PageCircleItem = forwardRef((props, ref) => {
  // log("PageCircleItem", ref)

  const { alignment, color, fromTop, orbit, size, ready, extraClasses, hideRing } = props

  const styAttr = {
    ...(fromTop && {
      top: fromTop
    })
  }

  log("strAttr", styAttr)

  return (
    <>
      <div
        ref={ref}
        className={css(
          ready,
          Styles[`wrapper__${size}`],
          Styles[`wrapper__align__${alignment}`],
          Styles[`wrapper__color__${color}`],
          extraClasses && extraClasses.wrapper
        )}
        style={styAttr}
      >
        <div
          className={css(
            Styles.circles,
            Styles[`circle__${size}`],
            Styles[`circle__color__${color}`],
            extraClasses && extraClasses.circle
          )}
        >
          <div
            className={css(
              Styles.rings,
              Styles[`ring__${size}`],
              Styles[`ring__color__${color}`],
              hideRing && Styles.ringsHidden,
              Styles[`ring__align__${alignment}`],
              extraClasses && extraClasses.ring
            )}
          >
            {orbit && (
              <div
                className={css(
                  Styles.dots,
                  Styles[`dot__${size}`],
                  Styles[`dot__align__${alignment}`],
                  Styles[`dot__color__${color}`],
                  extraClasses && extraClasses.dot
                )}
              />
            )}
          </div>
        </div>
      </div>
    </>
  )
})

export default PageCircleItem
